import { removeSpacesAndHTML } from '../../../services//general.utils';

class TagPayload {
    constructor(payload = {}) {        
        this.id = payload.id || null;
        this.name = payload.name ? removeSpacesAndHTML(payload.name) : "";
        this. description = payload.description ? removeSpacesAndHTML(payload.description) : "";
    }
  }  
  export default TagPayload;